// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fg","advertDetailParameterList__header":"c-p_fh","advertDetailParameterList__list":"c-p_fi"};